import React from 'react';
import { Icon } from 'semantic-ui-react';

const CustomSnackbar = ({ visible, title, message, onClose, type = 'warning' }) => {
  if (!visible) return null;

  const config = {
    warning: { icon: 'exclamation', color: '#FF9F0A', bg: 'rgba(255,159,10,0.15)', border: '#FF9F0A' },
    error:   { icon: 'warning circle', color: '#FF3B30', bg: 'rgba(255,59,48,0.15)', border: '#FF3B30' },
    success: { icon: 'check circle', color: '#34C759', bg: 'rgba(52,199,89,0.15)', border: '#34C759' },
  };
  const { icon, color, bg, border } = config[type] || config.warning;

  return (
    <div style={{
      position: 'fixed',
      top: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 2000,
      animation: 'fadeInDown 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
      // Never wider than the screen: a fixed 500px minimum ran off both edges on phones.
      minWidth: 'min(500px, calc(100vw - 32px))',
      maxWidth: 'min(600px, calc(100vw - 32px))',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        background: 'linear-gradient(135deg, rgba(28,28,32,0.97) 0%, rgba(36,36,42,0.97) 100%)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        padding: '20px 24px',
        borderRadius: '18px',
        boxShadow: '0 12px 40px rgba(0,0,0,0.25), 0 2px 8px rgba(0,0,0,0.15)',
        color: '#fff',
        gap: '16px',
        border: `1px solid rgba(255,255,255,0.1)`,
        borderLeft: `4px solid ${border}`,
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '44px',
          height: '44px',
          borderRadius: '12px',
          backgroundColor: bg,
          flexShrink: 0,
          marginTop: '1px',
        }}>
          <Icon name={icon} style={{ color, fontSize: '20px', margin: 0 }} />
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: '700', fontSize: '15px', marginBottom: '5px', letterSpacing: '-0.2px' }}>{title}</div>
          <div style={{ fontSize: '13px', opacity: 0.65, lineHeight: '1.5', wordBreak: 'break-word' }}>{message}</div>
        </div>

        <div
          onClick={onClose}
          style={{
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0.45,
            flexShrink: 0,
            marginTop: '2px',
            transition: 'opacity 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = 0.9}
          onMouseLeave={e => e.currentTarget.style.opacity = 0.45}
        >
          <Icon name='close' style={{ margin: 0, fontSize: '15px' }} />
        </div>
      </div>
      <style>{`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translate(-50%, -16px); }
          to   { opacity: 1; transform: translate(-50%, 0); }
        }
      `}</style>
    </div>
  );
};

export default CustomSnackbar;
